import { HelpIconTooltip } from "@components/common/help-icon-tooltip";
import { Dropdown, DropdownProps, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";

interface Props extends DropdownProps {
  /** A text to show as a help icon tooltip */
  helpTooltip: string;
}

/** A dropdown with a help icon tooltip on the right */
export function DropdownWithHelp({
  helpTooltip,
  ...dropdownProps
}: Props): React.JSX.Element {
  const { label } = dropdownProps;

  return (
    <Stack spacing={1} sx={{ mt: 2 }}>
      {label ? <Text variant="labelM">{label}</Text> : null}

      <Stack spacing={1} sx={{ flexDirection: "row", alignItems: "center" }}>
        <Dropdown
          value={dropdownProps.value}
          onChange={dropdownProps.onChange}
          variant={dropdownProps.variant}
          label={undefined}
          disabled={dropdownProps.disabled}
          options={dropdownProps.options}
          containerSx={{ flex: dropdownProps.fullWidth ? 1 : undefined }}
          // Match the height of the adjacent flat-ui text fields, whose height is
          // fixed by the library and only reproducible with an explicit pixel value
          sx={
            dropdownProps.variant === "underlined"
              ? undefined
              : { py: "11.5px" }
          }
        />

        <HelpIconTooltip title={helpTooltip} />
      </Stack>
    </Stack>
  );
}
